import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import {
	fetchInAppNotifications,
	markInAppNotificationRead,
} from '../../store/notification/notificationActions';

function labelForType(type) {
	switch (type) {
		case 'admin_tutor_pending_moderation':
			return 'Tutor submitted profile for moderation';
		case 'admin_withdrawal_request':
			return 'New withdrawal request';
		default:
			return type || 'Notification';
	}
}

function linkForNotification(n) {
	const p = n.payload || {};
	if (p.tutorProfileId) return `/users/moderate/${p.tutorProfileId}`;
	if (p.withdrawId) return '/wallet';
	return '/users/moderation';
}

export function AdminNotificationsPage() {
	const dispatch = useDispatch();
	const { inAppItems, inAppLoading, inAppTotal } = useSelector((s) => s.notification);

	useEffect(() => {
		dispatch(fetchInAppNotifications({ limit: 50 }));
	}, [dispatch]);

	return (
		<div className="max-w-3xl mx-auto px-4 py-8">
			<h1 className="text-2xl font-semibold text-nt-blue mb-2">Notifications</h1>
			<p className="text-nt-grey mb-6">{inAppTotal ? `${inAppTotal} total` : ' '}</p>
			{inAppLoading && <p className="text-nt-grey">Loading…</p>}
			<ul className="space-y-3">
				{inAppItems.map((n) => (
					<li
						key={n.id}
						className={`rounded-xl border p-4 ${
							n.readAt ? 'border-nt-grey-light bg-white' : 'border-nt-blue/30 bg-slate-50'
						}`}
					>
						<div className="flex justify-between gap-3 items-start">
							<div>
								<p className="font-medium text-nt-blue">{labelForType(n.type)}</p>
								<p className="text-sm text-nt-grey mt-1">
									{n.createdAt ? new Date(n.createdAt).toLocaleString() : ''}
								</p>
							</div>
							<div className="flex flex-col items-end gap-2 shrink-0">
								<Link
									to={linkForNotification(n)}
									className="text-sm text-nt-blue hover:underline"
									onClick={() => {
										if (!n.readAt) dispatch(markInAppNotificationRead(n.id));
									}}
								>
									Open
								</Link>
								{!n.readAt && (
									<button
										type="button"
										className="text-xs text-nt-grey hover:text-nt-blue"
										onClick={() => dispatch(markInAppNotificationRead(n.id))}
									>
										Mark read
									</button>
								)}
							</div>
						</div>
					</li>
				))}
			</ul>
			{!inAppLoading && inAppItems.length === 0 && (
				<p className="text-nt-grey mt-4">No notifications yet.</p>
			)}
		</div>
	);
}
